import DOMPurify from "dompurify";

// Allowlist for rendering untrusted email/quote HTML. Forbids script, event
// handlers, and javascript:/data:text-html vectors. Keeps images/links/tables
// (freight emails rely on them) but neutralizes active content.
//
// DOMPurify already strips on* event handlers and javascript: URLs by default;
// the config below additionally drops style/iframe/object/embed/form tags and
// data-* / srcset attributes so a crafted inbound email cannot exfiltrate the
// JWT (persisted in localStorage) via <img src=x onerror=...> or similar.
export function sanitizeEmailHtml(dirty) {
  return DOMPurify.sanitize(String(dirty || ""), {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form"],
    FORBID_ATTR: ["srcset"],
    ADD_ATTR: ["target"],
    ALLOW_DATA_ATTR: false,
  });
}
